import { Option } from '../option';
import { ObjectOps } from '../lift';
/**
 * Returns the value found at the provided key, as an Option.
 * Usage 1: read a value from a "Map" object
 * Usage 2: read an optional value from a domain object
 */
export function get(key) {
    return Option(this.value()[key]);
}
ObjectOps.prototype.get = get;
